import type { ComponentProps } from 'react';

const AddMember = (props: ComponentProps<'svg'>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    {...props}
  >
    <g clip-path="url(#clip0_10217_54318)">
      <path
        d="M7.01875 1.54141C7.67765 1.54141 8.30956 1.80315 8.77547 2.26906C9.24138 2.73497 9.50313 3.36688 9.50313 4.02578C9.50313 4.68468 9.24138 5.31659 8.77547 5.7825C8.30956 6.24841 7.67765 6.51016 7.01875 6.51016C6.35985 6.51016 5.72794 6.24841 5.26203 5.7825C4.79612 5.31659 4.53437 4.68468 4.53437 4.02578C4.53437 3.36688 4.79612 2.73497 5.26203 2.26906C5.72794 1.80315 6.35985 1.54141 7.01875 1.54141ZM7.01875 8.00078C8.07299 8.00078 9.08404 7.58199 9.8295 6.83653C10.575 6.09107 10.9937 5.08002 10.9937 4.02578C10.9937 2.97155 10.575 1.96049 9.8295 1.21503C9.08404 0.469575 8.07299 0.0507813 7.01875 0.0507812C5.96451 0.0507813 4.95346 0.469575 4.208 1.21503C3.46254 1.96049 3.04375 2.97155 3.04375 4.02578C3.04375 5.08002 3.46254 6.09107 4.208 6.83653C4.95346 7.58199 5.96451 8.00078 7.01875 8.00078ZM5.59955 10.982H8.43795C10.4782 10.982 12.1676 12.4944 12.444 14.4602H1.5935C1.86988 12.4944 3.55926 10.982 5.59955 10.982ZM5.59955 9.49141C2.54066 9.49141 0.0625 11.9696 0.0625 15.0285C0.0625 15.5378 0.475527 15.9508 0.984824 15.9508H13.0527C13.562 15.9508 13.975 15.5378 13.975 15.0285C13.975 11.9696 11.4968 9.49141 8.43795 9.49141H5.59955ZM15.7141 9.73984C15.7141 10.1529 16.0463 10.4852 16.4594 10.4852C16.8724 10.4852 17.2047 10.1529 17.2047 9.73984V7.75234H19.1922C19.6052 7.75234 19.9375 7.42006 19.9375 7.00703C19.9375 6.594 19.6052 6.26172 19.1922 6.26172H17.2047V4.27422C17.2047 3.86119 16.8724 3.52891 16.4594 3.52891C16.0463 3.52891 15.7141 3.86119 15.7141 4.27422V6.26172H13.7266C13.3135 6.26172 12.9812 6.594 12.9812 7.00703C12.9812 7.42006 13.3135 7.75234 13.7266 7.75234H15.7141V9.73984Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_10217_54318">
        <rect
          width="19.875"
          height="15.9"
          fill="white"
          transform="translate(0.0625 0.0507812)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default AddMember;
